import Tracking from "../views/Public/Tracking";
import CotacaoSpot from "../views/Public/CotacaoSpot";
import OnboardingKit from "../views/Public/OnboardingKit";
import ConviteTransportadora from "../views/Public/ConviteTransportadora";
import LeilaoFrete from "../views/Public/LeilaoFrete";
import RedeEverlog from "../views/Public/RedeEverlog";

const routes = [
  {
    // Pedido de entrada na Rede Everlog (PO1-3647, épico PO1-3359): página
    // aberta, sem token; captcha e limiter ficam no backend.
    path: "/rede-everlog",
    name: "Rede Everlog",
    component: RedeEverlog,
    layout: "/public",
    invisible: true,
  },
  {
    // Lance da transportadora no Leilão Reverso de Frete (PO1-3083): o token é o acesso.
    path: "/leilao-frete/:token",
    name: "Leilão de Frete",
    component: LeilaoFrete,
    layout: "/public",
    invisible: true,
  },
  {
    // Aceite do convite da transportadora (PO1-2299): o token é o acesso.
    path: "/convite-transportadora/:token",
    name: "Convite da Transportadora",
    component: ConviteTransportadora,
    layout: "/public",
    invisible: true,
  },
  {
    path: "/tracking",
    name: "Tracking",
    component: Tracking,
    layout: "/public",
    invisible: true,
  },
  {
    path: "/cotacao-spot/:token",
    name: "Cotação Spot",
    component: CotacaoSpot,
    layout: "/public",
    invisible: true,
  },
  {
    path: "/onboarding-kit/:token",
    name: "Kit de Onboarding",
    component: OnboardingKit,
    layout: "/public",
    invisible: true,
  },
];

export default routes;
